import { render, staticRenderFns } from "./assetFlow.vue?vue&type=template&id=6ba7865c&scoped=true&"
import script from "./assetFlow.vue?vue&type=script&lang=js&"
export * from "./assetFlow.vue?vue&type=script&lang=js&"
import style0 from "./assetFlow.vue?vue&type=style&index=0&id=6ba7865c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7865c",
  null
  
)

export default component.exports